import { element } from 'protractor';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ResizeHorizontalService {
    constructor() {}

    resizableGrid(table) {
        var row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined;
        if (!cols) return;

        // table.style.overflow = 'hidden';

        for (var i = 0; i < cols.length; i++) {
            if(cols[i].classList.contains('sticky')) {
                continue;
            }
            var div = this.createDiv();
            cols[i].appendChild(div);
            cols[i].style.position = 'relative';
            this.setListeners(div, table.id);
        }
    }

    createDiv() {
        var div = document.createElement('div');
        div.style.top = '0';
        div.style.right = '0';
        div.style.width = '5px';
        div.style.position = 'absolute';
        div.style.cursor = 'col-resize';
        div.style.userSelect = 'none';
        div.style.height = '48px';
        // div.style.borderRight = '1px solid rgba(92, 119, 255, 1)';
        return div;
    }

    paddingDiff(col) {
        if (this.getStyleVal(col, 'box-sizing') == 'border-box') {
            return 0;
        }
        var padLeft = this.getStyleVal(col, 'padding-left');
        var padRight = this.getStyleVal(col, 'padding-right');
        return parseInt(padLeft) + parseInt(padRight);
    }

    getStyleVal(elm, css) {
        return window.getComputedStyle(elm, null).getPropertyValue(css);
    }

    setListeners(div, tableId) {
        var pageX, curCol, curColWidth, tableWidth;
        let scope = this;
        div.addEventListener('mousedown', function (e) {
            document.addEventListener('mousemove', moveElement);
            document.addEventListener('mouseup', removeListener);
            tableWidth = document.getElementById(tableId).offsetWidth;
            curCol = e.target.parentElement;
            pageX = e.pageX;

            var padding = scope.paddingDiff(curCol);

            curColWidth = curCol.offsetWidth - padding;
        });

        function removeListener() {
            document.removeEventListener("mousemove", moveElement);
            document.removeEventListener("mouseup", removeListener)
        }

        function moveElement(e) {
            var diffX = e.pageX - pageX;
            let newWidth = Math.max(50, curColWidth + diffX);
            curCol.style.minWidth = `${newWidth}px`;
            document.getElementById(tableId).style.minWidth = `${Math.max(tableWidth, tableWidth + diffX)}px`;
        }
    }
}
